import { render, staticRenderFns } from "./CheckoutItemsSummary.vue?vue&type=template&id=45eca5b8&"
import script from "./CheckoutItemsSummary.vue?vue&type=script&lang=js&"
export * from "./CheckoutItemsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports